// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

let port = 5001;

const ip = window.location.protocol + "//" + document.location.hostname;

if (window.location.protocol == "https:") {
  port = 5011;
}

export const environment = {
  production: false,
  apiURL: `${ip}:${port}`,
  cryptoKey: "54LT3rE3Qc4UAFSSoBqqOsr9hJpAJRms",
};

export const routes = {
  searches_contracts: `${environment.apiURL}/products/v1/debtors/searches/contracts`, // rota sem autenticação

  searches_contracts2: `${environment.apiURL}/products/v1/tscobra/contracts/allcompanies?keyui=yaXf4qGwJr&moduleui=app-debtor&statuscontract=abletoshowonatende`,

  payment: `${environment.apiURL}/products/v1/debtors/agreements/payments`,

  auth_searches_contracts: `${environment.apiURL}/products/v1/tscobra/contracts`,

  agreements: `${environment.apiURL}/products/v1/tscobra/agreements`,
  boleto: `${environment.apiURL}/products/v1/tscobra/agreements/payments/invoices`,
  garantias: `${environment.apiURL}/products/v1/tscobra/guarantees`,
  headers: `${environment.apiURL}/products/v1/tscobra/offices/headers`,
  offices: `${environment.apiURL}/products/v1/tscobra/offices`,
  contracts: `${environment.apiURL}/products/v1/tscobra/contracts`,

  invoice: `${environment.apiURL}/services/v1/invoices/boletos/create`,
  login: `${environment.apiURL}/sessions/v1/auth/login`,
  logout: `${environment.apiURL}/sessions/v1/auth/logout`,
  validate: `${environment.apiURL}/sessions/v1/auth/validate`,
  send_sms: `${environment.apiURL}/products/v1/tscobra/channels/sms/defaults`,
  send_email: `${environment.apiURL}/products/v1/tscobra/channels/emails/defaults`,
  toPdf: `${environment.apiURL}/services/v1/exports/pdf`,
  chat_parameters: `${environment.apiURL}/services/v1/multichannel/parameters`,
  parameters: `${environment.apiURL}/services/v1/multichannel/parameters`,
  event_attendance: `${environment.apiURL}/products/v1/tscobra/channels/atende/attendances`,
  whatsapp: `http://10.0.0.208:5001/products/v1/whatsapp/start`,

  options: `${environment.apiURL}/products/v1/tscobra/negotiations/payments/options?paymentonlytoatende=true`,

  received: `${environment.apiURL}/products/v1/tscobra/negotiations/sales`,
  opt_parcelamento: `${environment.apiURL}/products/v1/tscobra/negotiations`,
  envio_email_proposals: `${environment.apiURL}/products/v1/tscobra/channels/emails/proposals`,
  consultar_parcelas_cobra: `${environment.apiURL}/products/v1/tscobra/contracts/installments`,
  acordo_inclusao: `${environment.apiURL}/products/v1/tscobra/agreements?parcelsOfAgreementDefault=true`,
  // redirect: `${environment.apiURL}/sessions/v1/directions/companies/products/?idproduct=2&keyservicecompany=`,
  send_key_2_factor: `${environment.apiURL}/products/v1/tscobra/channels/atende/sendkey2factor`,
  validate_key_2_factor: `${environment.apiURL}/products/v1/tscobra/channels/atende/validkey2factor`,
  get_contacts: `${environment.apiURL}/products/v1/tscobra/contracts/contacts`,
};
//smtp config
export const smtpConfig = {
  Smtp: "smtp.gmail.com",
  SmtpPorta: 587,
  SmtpUsuario: "teixeira.developer@gmail.com",
  SmtpSenha: "botucatu@30",
  From: "teixeira.developer@gmail.com",
  ModuleSystem: "Atende",
  VersionSystem: "2.03.09b",
  IpSystem: "10.0.0.108",
};
